export default __webpack_public_path__ + "static/media/least_recent_spenders.0eeb8721.svg";